(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {

    function initBundleModal(bundleModal) {
      var overlay           = bundleModal.querySelector('[data-bundle-modal-overlay]');
      var closeBtn          = bundleModal.querySelector('[data-bundle-modal-close]');
      var products          = bundleModal.querySelectorAll('[data-bundle-product]');
      var selectedCountEl   = bundleModal.querySelector('[data-bundle-selected-count]');
      var maxCountEl        = bundleModal.querySelector('[data-bundle-max-count]');
      var discountEl        = bundleModal.querySelector('[data-bundle-discount]');
      var originalPriceEl   = bundleModal.querySelector('[data-bundle-original-price]');
      var discountedPriceEl = bundleModal.querySelector('[data-bundle-discounted-price]');
      var addToCartBtn      = bundleModal.querySelector('[data-bundle-add-to-cart]');

      var variantScreen     = bundleModal.querySelector('[data-variant-screen]');
      var variantList       = bundleModal.querySelector('[data-variant-list]');
      var variantProduct    = bundleModal.querySelector('[data-variant-product]');
      var variantTitle      = bundleModal.querySelector('[data-variant-screen-title]');
      var variantBackBtn    = bundleModal.querySelector('[data-variant-back]');
      var variantCloseBtn   = bundleModal.querySelector('[data-variant-screen-close]');
      var mainContent       = bundleModal.querySelector('.bundle-modal__content');

      if (!overlay || !closeBtn || !addToCartBtn) return;

      var maxProducts      = 2;
      var discountPercent  = 20;
      var selectedProducts = [];

      var currentProduct = bundleModal.querySelector('[data-is-current="true"]');
      if (currentProduct) selectedProducts.push(toData(currentProduct));

      function toData(el) {
        return {
          id:        el.dataset.productId,
          variantId: el.dataset.variantId,
          price:     parseInt(el.dataset.productPrice, 10),
          title:     el.dataset.productTitle
        };
      }

      function close() {
        bundleModal.classList.remove('active');
        document.body.style.overflow = '';
        closeVariantPicker();
      }

      function closeVariantPicker() {
        if (variantScreen) variantScreen.classList.remove('active');
        if (mainContent)   mainContent.classList.remove('hidden');
      }

      function openVariantPicker(productEl) {
        var handle = productEl.dataset.productHandle;
        var imgEl  = productEl.querySelector('img');
        var title  = productEl.dataset.productTitle || '';

        if (variantTitle) variantTitle.textContent = title;

        if (variantProduct) {
          variantProduct.innerHTML =
            '<div class="bundle-modal__variant-product-image">' +
            (imgEl ? '<img src="' + imgEl.src + '" alt="" width="48" height="48" loading="lazy">' : '') +
            '</div>' +
            '<span class="bundle-modal__variant-product-name">' + title + '</span>';
        }

        if (variantList) variantList.innerHTML = '<p class="bundle-modal__variant-loading">Chargement…</p>';
        if (variantScreen) variantScreen.classList.add('active');
        if (mainContent)   mainContent.classList.add('hidden');

        if (!handle) { closeVariantPicker(); directSelect(productEl); return; }

        fetch('/products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (!variantScreen || !variantScreen.classList.contains('active')) return;
            var variants = data.variants;
            if (variants.length === 1) {
              productEl.dataset.variantId    = variants[0].id;
              productEl.dataset.productPrice = variants[0].price;
              closeVariantPicker();
              directSelect(productEl);
              return;
            }
            renderVariants(variants, productEl);
          })
          .catch(function() { closeVariantPicker(); directSelect(productEl); });
      }

      function renderVariants(variants, productEl) {
        if (!variantList) return;
        variantList.innerHTML = '';
        variants.forEach(function(v) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bundle-modal__variant-item';
          btn.disabled = !v.available;
          btn.innerHTML =
            '<span class="bundle-modal__variant-item-title">' + v.title + '</span>' +
            '<span class="bundle-modal__variant-item-price">' + (v.price / 100).toFixed(2).replace('.', ',') + '€</span>';
          btn.addEventListener('click', function() {
            productEl.dataset.variantId    = v.id;
            productEl.dataset.productPrice = v.price;
            // Mettre à jour le prix affiché dans la liste produit
            var priceEl = productEl.querySelector('.bundle-modal__product-price');
            if (priceEl) priceEl.textContent = (v.price / 100).toFixed(2).replace('.', ',') + '€';
            closeVariantPicker();
            directSelect(productEl);
          });
          variantList.appendChild(btn);
        });
      }

      function directSelect(el) {
        if (el.dataset.isCurrent === 'true') return;
        if (el.classList.contains('bundle-modal__product--disabled')) return;
        var data = toData(el);
        var idx  = selectedProducts.findIndex(function(p) { return p.id === data.id; });
        if (idx > -1) {
          selectedProducts.splice(idx, 1);
          el.classList.remove('bundle-modal__product--selected');
        } else if (selectedProducts.length < maxProducts) {
          selectedProducts.push(data);
          el.classList.add('bundle-modal__product--selected');
        }
        updateUI();
      }

      function toggle(el) {
        if (el.dataset.isCurrent === 'true') return;
        if (el.classList.contains('bundle-modal__product--disabled')) return;
        // Déselection directe sans passer par le picker
        if (el.classList.contains('bundle-modal__product--selected')) {
          directSelect(el);
          return;
        }
        openVariantPicker(el);
      }

      function updateUI() {
        selectedCountEl.textContent = selectedProducts.length;
        var orig = selectedProducts.reduce(function(s, p) { return s + p.price; }, 0);
        var disc = orig * (1 - discountPercent / 100);
        originalPriceEl.textContent  = (orig / 100).toFixed(2).replace('.', ',') + '€';
        discountedPriceEl.textContent = (disc / 100).toFixed(2).replace('.', ',') + '€';
        if (selectedProducts.length === maxProducts) {
          addToCartBtn.disabled = false;
          products.forEach(function(p) {
            if (!p.classList.contains('bundle-modal__product--selected'))
              p.classList.add('bundle-modal__product--disabled');
          });
        } else {
          addToCartBtn.disabled = true;
          products.forEach(function(p) {
            if (p.dataset.isCurrent !== 'true')
              p.classList.remove('bundle-modal__product--disabled');
          });
        }
      }

      products.forEach(function(p) {
        p.addEventListener('click', function() { toggle(p); });
      });

      overlay.addEventListener('click', close);
      closeBtn.addEventListener('click', close);
      if (variantBackBtn)  variantBackBtn.addEventListener('click', closeVariantPicker);
      if (variantCloseBtn) variantCloseBtn.addEventListener('click', close);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && bundleModal.classList.contains('active')) {
          if (variantScreen && variantScreen.classList.contains('active')) {
            closeVariantPicker();
          } else {
            close();
          }
        }
      });

      addToCartBtn.addEventListener('click', function() {
        if (selectedProducts.length !== maxProducts) return;
        addToCartBtn.disabled = true;
        var btnText = addToCartBtn.querySelector('.button__text');
        if (btnText) btnText.textContent = bundleModal.dataset.addingText;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: selectedProducts.map(function(p) {
              return {
                id: parseInt(p.variantId, 10),
                quantity: 1,
                properties: { '_bundle_discount': discountPercent + '%', '_bundle_size': maxProducts }
              };
            })
          })
        }).then(function(r) {
          if (r.ok) {
            close();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { openDrawer: true } }));
          }
        }).catch(function(e) { console.error('[bundle-modal] cart error:', e); })
          .finally(function() {
            addToCartBtn.disabled = false;
            if (btnText) btnText.textContent = bundleModal.dataset.addToCartText;
          });
      });

      var discountBanner = bundleModal.querySelector('[data-bundle-discount-banner]');

      bundleModal._openBundleModal = function(count, discount) {
        maxProducts     = count;
        discountPercent = discount;
        maxCountEl.textContent = count;
        discountEl.textContent = discount;
        if (discountBanner) discountBanner.style.display = discount === 0 ? 'none' : '';
        selectedProducts = currentProduct ? [toData(currentProduct)] : [];
        products.forEach(function(p) {
          if (p.dataset.isCurrent !== 'true') {
            p.classList.remove('bundle-modal__product--selected');
            p.classList.remove('bundle-modal__product--disabled');
          }
        });
        closeVariantPicker();
        updateUI();
        bundleModal.classList.add('active');
        document.body.style.overflow = 'hidden';
      };
    }

    document.querySelectorAll('[data-bundle-modal]').forEach(initBundleModal);

    document.querySelectorAll('[data-suggestion-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        var count    = parseInt(trigger.dataset.productCount, 10) || 2;
        var discount = parseInt(trigger.dataset.discount, 10) || 20;
        var modalId  = trigger.dataset.modalId;
        var target   = modalId
          ? document.querySelector('[data-bundle-modal="' + modalId + '"]')
          : document.querySelector('[data-bundle-modal]');
        if (target && target._openBundleModal) target._openBundleModal(count, discount);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-selector"] && !Shopify.designMode) return;
  try {
    (function() {
    const selector = document.querySelector('[data-language-selector]');
    if (!selector) return;

    const trigger = selector.querySelector('[data-language-trigger]');
    const dropdown = selector.querySelector('[data-language-dropdown]');

    function toggleDropdown() {
      const isOpen = selector.getAttribute('data-open') === 'true';
      selector.setAttribute('data-open', !isOpen);
      trigger.setAttribute('aria-expanded', !isOpen);
    }

    function closeDropdown() {
      selector.setAttribute('data-open', 'false');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', toggleDropdown);

    document.addEventListener('click', function(e) {
      if (!selector.contains(e.target)) {
        closeDropdown();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeDropdown();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["poster-card"] && !Shopify.designMode) return;
  try {
    (function () {
    function checkImageOrientation() {
      const imageWrappers = document.querySelectorAll('[data-image-wrapper]');

      imageWrappers.forEach((wrapper) => {
        const primaryImage = wrapper.querySelector('.poster-card__image--primary');
        const secondaryImage = wrapper.querySelector('.poster-card__image--secondary');
        const background = wrapper.querySelector('.poster-card__image-background');

        function updateOrientation(img) {
          if (!img) return;

          const width = parseInt(img.getAttribute('data-image-width'));
          const height = parseInt(img.getAttribute('data-image-height'));

          // Si l'image est horizontale (largeur > hauteur)
          if (width > height) {
            wrapper.classList.add('poster-card__image-wrapper--horizontal');
            // Définir l'image de fond
            if (background) {
              background.style.backgroundImage = `url(${img.src})`;
            }
          } else {
            wrapper.classList.remove('poster-card__image-wrapper--horizontal');
          }
        }

        // Vérifier l'image principale au chargement
        if (primaryImage) {
          updateOrientation(primaryImage);
        }

        // Mettre à jour lors du hover si une image secondaire existe
        if (secondaryImage) {
          const link = wrapper.closest('.poster-card__link');
          if (link) {
            link.addEventListener('mouseenter', () => {
              updateOrientation(secondaryImage);
            });

            link.addEventListener('mouseleave', () => {
              updateOrientation(primaryImage);
            });
          }
        }
      });
    }

    // Exécuter au chargement de la page
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkImageOrientation);
    } else {
      checkImageOrientation();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    const searchModal = document.querySelector('[data-search-modal]');
    const searchModalOverlay = document.querySelector('[data-search-modal-overlay]');
    const searchModalTrigger = document.querySelector('[data-search-modal-trigger]');
    const searchModalClose = document.querySelector('[data-search-modal-close]');
    const searchInput = document.querySelector('[data-search-input]');
    const searchResults = document.querySelector('[data-search-results]');
    const searchClear = document.querySelector('[data-search-clear]');
    const searchForm = document.querySelector('[data-search-form]');

    // Load translations
    let translations = {};
    const translationsElement = document.querySelector('[data-search-translations]');
    if (translationsElement) {
      try {
        translations = JSON.parse(translationsElement.textContent);
      } catch (e) {
        console.error('Error parsing search translations:', e);
      }
    }

    let searchTimeout;
    let highlightedIndex = -1;
    let currentResults = [];

    function openSearchModal() {
      searchModal.classList.add('active');
      searchModalOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      highlightedIndex = -1;

      setTimeout(() => {
        searchInput.focus();
      }, 300);
    }

    function closeSearchModal() {
      searchModal.classList.remove('active');
      searchModalOverlay.classList.remove('active');
      document.body.style.overflow = '';
      searchInput.value = '';
      highlightedIndex = -1;
      currentResults = [];
      searchResults.innerHTML = '';
    }

    if (searchModalTrigger) {
      searchModalTrigger.addEventListener('click', openSearchModal);
    }

    if (searchModalClose) {
      searchModalClose.addEventListener('click', closeSearchModal);
    }

    if (searchModalOverlay) {
      searchModalOverlay.addEventListener('click', closeSearchModal);
    }

    // Prevent form submission and handle keyboard navigation
    if (searchForm) {
      searchForm.addEventListener('submit', function(e) {
        e.preventDefault();

        // If a result is highlighted, navigate to it
        const highlighted = searchResults.querySelector('.search-modal__result-item.highlighted');
        if (highlighted) {
          window.location.href = highlighted.href;
          return;
        }

        // If there are results, navigate to the first one
        const firstResult = searchResults.querySelector('.search-modal__result-item');
        if (firstResult) {
          window.location.href = firstResult.href;
        }
      });
    }

    document.addEventListener('keydown', (e) => {
      if (!searchModal.classList.contains('active')) return;

      if (e.key === 'Escape') {
        closeSearchModal();
        return;
      }

      const items = searchResults.querySelectorAll('.search-modal__result-item');
      if (items.length === 0) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        highlightedIndex = Math.min(highlightedIndex + 1, items.length - 1);
        updateHighlight(items);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        highlightedIndex = Math.max(highlightedIndex - 1, -1);
        updateHighlight(items);
      } else if (e.key === 'Enter' && highlightedIndex >= 0) {
        e.preventDefault();
        items[highlightedIndex].click();
      }
    });

    function updateHighlight(items) {
      items.forEach((item, index) => {
        item.classList.toggle('highlighted', index === highlightedIndex);
        if (index === highlightedIndex) {
          item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });
    }

    // Clear button functionality
    if (searchClear && searchInput) {
      searchClear.addEventListener('click', function() {
        searchInput.value = '';
        searchClear.style.display = 'none';
        highlightedIndex = -1;
        currentResults = [];
        searchResults.innerHTML = '';
        searchInput.focus();
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function (e) {
        const query = e.target.value.trim();
        highlightedIndex = -1;

        // Show/hide clear button
        if (searchClear) {
          searchClear.style.display = query.length > 0 ? 'flex' : 'none';
        }

        clearTimeout(searchTimeout);

        if (query.length < 2) {
          searchResults.innerHTML = '';
          return;
        }

        searchResults.innerHTML = '<div class="search-modal__loading"></div>';

        searchTimeout = setTimeout(() => {
          performSearch(query);
        }, 300);
      });
    }

    // Load artists list from Liquid-generated JSON
    let allArtistsList = [];
    const artistsDataElement = document.querySelector('[data-artists-list]');
    if (artistsDataElement) {
      try {
        allArtistsList = JSON.parse(artistsDataElement.textContent);
      } catch (e) {
        console.error('Error parsing artists list:', e);
      }
    }

    function performSearch(query) {
      // Search products with more results to extract tags
      const productsUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&resources[options][fields]=title,body,tag,vendor,product_type`;

      // Search pages with wildcard (*) for partial matching and include body content
      const pagesUrl = `/search/suggest.json?q=${encodeURIComponent(query)}*&resources[type]=page&resources[limit]=5&resources[options][fields]=title,body`;

      // Also search by tag directly
      const tagSearchUrl = `/search/suggest.json?q=tag:${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`;

      Promise.all([
        fetch(productsUrl).then((res) => res.json()),
        fetch(pagesUrl).then((res) => res.json()),
        fetch(tagSearchUrl).then((res) => res.json()).catch(() => ({ resources: { results: { products: [] } } }))
      ])
        .then(([productsData, pagesData, tagProductsData]) => {
          const products = productsData.resources.results.products || [];
          const pages = pagesData.resources.results.pages || [];
          const tagProducts = tagProductsData.resources.results.products || [];

          // Merge products, removing duplicates
          const allProducts = [...products];
          tagProducts.forEach(tp => {
            if (!allProducts.find(p => p.id === tp.id)) {
              allProducts.push(tp);
            }
          });

          const tagsMap = new Map();
          const queryLower = query.toLowerCase();

          // Helper function to convert string to handle format (like Shopify's handleize)
          function handleize(str) {
            return str.toLowerCase()
              .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
              .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric with hyphens
              .replace(/^-+|-+$/g, ''); // Trim hyphens from start/end
          }

          // Search artists from the pre-loaded list (from metafields)
          const matchingArtists = allArtistsList
            .filter(artist => {
              const nameLower = artist.name.toLowerCase();
              const handleLower = artist.handle.toLowerCase();
              return nameLower.includes(queryLower) || handleLower.includes(queryLower);
            })
            .slice(0, 3)
            .map(artist => ({
              name: artist.name,
              handle: artist.handle,
              url: `/collections/all?filter.artist=${encodeURIComponent(artist.handle)}`
            }));

          // Rarity tags to filter separately
          const rarityTags = ['rare', 'epique', 'legendary', 'mythique'];

          allProducts.forEach(product => {
            // Check product type - use filter.p.product_type with handleized value
            if (product.product_type && product.product_type.toLowerCase().includes(queryLower)) {
              const key = product.product_type.toLowerCase();
              if (!tagsMap.has(key)) {
                const typeHandle = handleize(product.product_type);
                tagsMap.set(key, {
                  name: product.product_type,
                  count: 1,
                  type: 'type',
                  url: `/collections/all?filter.p.product_type=${encodeURIComponent(typeHandle)}`
                });
              } else {
                tagsMap.get(key).count++;
              }
            }

            // Check tags
            if (product.tags && Array.isArray(product.tags)) {
              product.tags.forEach(tag => {
                const tagLower = tag.toLowerCase();
                if (tagLower.includes(queryLower)) {
                  const key = tagLower;

                  // Check if it's a rarity tag
                  const isRarity = rarityTags.includes(tagLower);

                  if (!tagsMap.has(key)) {
                    tagsMap.set(key, {
                      name: tag,
                      count: 1,
                      type: isRarity ? 'rarity' : 'tag',
                      url: isRarity
                        ? `/collections/all?filter.rarity=${encodeURIComponent(tagLower)}`
                        : `/collections/all?filter.tag=${encodeURIComponent(handleize(tag))}`
                    });
                  } else {
                    tagsMap.get(key).count++;
                  }
                }
              });
            }
          });

          const tags = Array.from(tagsMap.values()).slice(0, 4);

          displayResults(products.slice(0, 5), pages, matchingArtists, tags);
        })
        .catch((error) => {
          console.error('Search error:', error);
          searchResults.innerHTML = '<div class="search-modal__empty"></div>';
        });
    }

    function displayResults(products, pages, artists, tags) {
      const hasProducts = products && products.length > 0;
      const hasPages = pages && pages.length > 0;
      const hasArtists = artists && artists.length > 0;
      const hasTags = tags && tags.length > 0;

      if (!hasProducts && !hasPages && !hasArtists && !hasTags) {
        searchResults.innerHTML = '<div class="search-modal__empty"></div>';
        return;
      }

      let resultsHTML = '';

      // Products section (first)
      if (hasProducts) {
        const productsHTML = products
          .map((product) => {
            const imageUrl = product.image || '';
            const priceValue = product.price ? parseFloat(product.price) : 0;
            const price = priceValue.toFixed(2);
            const compareAtPriceValue = product.compare_at_price ? parseFloat(product.compare_at_price) : null;
            const compareAtPrice = compareAtPriceValue ? compareAtPriceValue.toFixed(2) : null;
            const onSale = compareAtPrice && compareAtPriceValue > priceValue;
            const vendor = product.vendor ? `<p class="search-modal__result-meta">${product.vendor}</p>` : '';

            let priceHTML = '';
            if (onSale) {
              priceHTML = `
                <p class="search-modal__result-price">
                  <span class="search-modal__result-price--sale">${price}€</span>
                  <span class="search-modal__result-price--compare">${compareAtPrice}€</span>
                </p>
              `;
            } else {
              priceHTML = `<p class="search-modal__result-price">${price}€</p>`;
            }

            return `
            <a href="${product.url}" class="search-modal__result-item search-modal__result-item--product">
              ${
                imageUrl
                  ? `<img src="${imageUrl}" alt="${product.title}" class="search-modal__result-image" width="60" height="60" />`
                  : ''
              }
              <div class="search-modal__result-info">
                <h3 class="search-modal__result-title">${product.title}</h3>
                ${vendor}
                ${priceHTML}
              </div>
            </a>
          `;
          })
          .join('');

        resultsHTML += `<div class="search-modal__section-title">${translations.products || 'Products'}</div>${productsHTML}`;
      }

      // Artists section (second)
      if (hasArtists) {
        const artistsHTML = artists
          .map((artist) => {
            return `
            <a href="${artist.url}" class="search-modal__result-item search-modal__result-item--artist">
              <div class="search-modal__result-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <div class="search-modal__result-info">
                <h3 class="search-modal__result-title">${artist.name}</h3>
                <p class="search-modal__result-meta">${translations.artist_partner || 'Artist / Partner'}</p>
              </div>
            </a>
          `;
          })
          .join('');

        resultsHTML += `<div class="search-modal__section-title">${translations.artists_partners || 'Artists / Partners'}</div>${artistsHTML}`;
      }

      // Tags section (third)
      if (hasTags) {
        const tagsHTML = tags
          .map((tag) => {
            // Determine label based on type
            let typeLabel = translations.tag || 'Tag';
            if (tag.type === 'type') {
              typeLabel = translations.category || 'Category';
            } else if (tag.type === 'rarity') {
              typeLabel = translations.rarity || 'Rarity';
            }

            // Format product count - replace placeholder with actual count
            const countPlaceholder = '{' + '{ count }' + '}';
            const productCountText = tag.count > 1
              ? (translations.products_plural || (tag.count + ' products')).replace(countPlaceholder, tag.count)
              : (translations.product || (tag.count + ' product')).replace(countPlaceholder, tag.count);

            return `
            <a href="${tag.url}" class="search-modal__result-item search-modal__result-item--tag${tag.type === 'rarity' ? ' search-modal__result-item--rarity' : ''}">
              <div class="search-modal__result-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                  <line x1="7" y1="7" x2="7.01" y2="7"></line>
                </svg>
              </div>
              <div class="search-modal__result-info">
                <h3 class="search-modal__result-title">${tag.name}</h3>
                <p class="search-modal__result-meta">${typeLabel} • ${productCountText}</p>
              </div>
            </a>
          `;
          })
          .join('');

        resultsHTML += `<div class="search-modal__section-title">${translations.tags_categories || 'Tags & Categories'}</div>${tagsHTML}`;
      }

      // Pages section (last)
      if (hasPages) {
        const pagesHTML = pages
          .map((page) => {
            return `
            <a href="${page.url}" class="search-modal__result-item search-modal__result-item--page">
              <div class="search-modal__result-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                </svg>
              </div>
              <div class="search-modal__result-info">
                <h3 class="search-modal__result-title">${page.title}</h3>
                <p class="search-modal__result-type">Page</p>
              </div>
            </a>
          `;
          })
          .join('');

        resultsHTML += `<div class="search-modal__section-title">Pages</div>${pagesHTML}`;
      }

      searchResults.innerHTML = `<div class="search-modal__results-list">${resultsHTML}</div>`;
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spotlight-trigger"] && !Shopify.designMode) return;
  try {
    (function() {
    // Initialize spotlight triggers from snippets
    function initSnippetSpotlights() {
      if (typeof driver === 'undefined') {
        console.error('Driver.js not loaded');
        return;
      }

      const triggers = document.querySelectorAll('[data-spotlight-trigger-snippet]');

      triggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();

          const targetSelector = this.getAttribute('data-spotlight-target');
          const title = this.getAttribute('data-spotlight-title');
          const description = this.getAttribute('data-spotlight-description');
          const buttonText = this.getAttribute('data-spotlight-button');
          const position = this.getAttribute('data-spotlight-position');

          const targetElement = document.querySelector(targetSelector);
          if (!targetElement) {
            console.error('Target element not found:', targetSelector);
            return;
          }

          const driverInstance = driver({
            showProgress: false,
            showButtons: ['close', 'next'],
            nextBtnText: buttonText,
            doneBtnText: buttonText,
            closeBtnText: '×',
            overlayColor: 'rgba(0, 0, 0, 0.7)',
            popoverClass: 'driver-popover-spotlight',
            animate: true,
            smoothScroll: true,
            allowClose: true
          });

          driverInstance.highlight({
            element: targetSelector,
            popover: {
              title: title,
              description: description,
              side: position,
              align: 'start'
            }
          });
        });
      });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSnippetSpotlights);
    } else {
      initSnippetSpotlights();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const variantModal = document.querySelector('[data-variant-modal]');
    if (!variantModal) return;

    const modalTriggers = document.querySelectorAll('[data-variant-modal-trigger]');
    const modalOverlay = variantModal.querySelector('[data-variant-modal-overlay]');
    const modalClose = variantModal.querySelector('[data-variant-modal-close]');
    const optionButtons = variantModal.querySelectorAll('.variant-modal__option-button');
    const optionSelects = variantModal.querySelectorAll('.variant-modal__option-select');
    const variantInput = variantModal.querySelector('[data-variant-input]');
    const addToCartButton = variantModal.querySelector('.variant-modal__add-button');
    const priceContainer = variantModal.querySelector('[data-variant-price]');
    const currentPriceEl = variantModal.querySelector('[data-current-price]');
    let comparePriceEl = variantModal.querySelector('[data-compare-price]');
    const buttonPriceEl = variantModal.querySelector('[data-button-price]');

    // Product variants data
    const variantsData = variantModal.getAttribute('data-variants');
    const variants = JSON.parse(variantsData);

    // Track selected options
    const selectedOptions = {};

    // Get total number of option groups
    const optionGroups = variantModal.querySelectorAll('.variant-modal__option-group');
    const totalOptionGroups = optionGroups.length;

    function openVariantModal(e) {
      e.preventDefault();
      e.stopPropagation();
      variantModal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeVariantModal() {
      variantModal.classList.remove('active');
      document.body.style.overflow = '';
    }

    modalTriggers.forEach((trigger) => {
      trigger.addEventListener('click', openVariantModal);
    });

    if (modalOverlay) {
      modalOverlay.addEventListener('click', closeVariantModal);
    }

    if (modalClose) {
      modalClose.addEventListener('click', closeVariantModal);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && variantModal.classList.contains('active')) {
        closeVariantModal();
      }
    });

    // Find variant by selected options
    function findVariantByOptions(options) {
      return variants.find(variant => {
        // Only compare options that exist in the product
        let matches = true;
        for (let i = 1; i <= totalOptionGroups; i++) {
          if (variant['option' + i] !== options[i]) {
            matches = false;
            break;
          }
        }
        return matches;
      });
    }

    // Format price (convert cents to formatted price)
    function formatPrice(priceInCents) {
      const price = (priceInCents / 100).toFixed(2);
      // Remove trailing zeros and format
      const formatted = parseFloat(price).toLocaleString('fr-FR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      return formatted + '€';
    }

    // Update variant info display
    function updateVariantInfo(variant) {
      if (!variant) return;

      // Update hidden input
      if (variantInput) {
        variantInput.value = variant.id;
      }

      // Update price display
      if (currentPriceEl) {
        currentPriceEl.textContent = formatPrice(variant.price);
      }

      // Update button price (mobile)
      if (buttonPriceEl) {
        buttonPriceEl.textContent = formatPrice(variant.price);
      }

      // Update compare at price
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (comparePriceEl) {
          comparePriceEl.textContent = formatPrice(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else if (priceContainer) {
          // Create compare price element if it doesn't exist
          const newCompareEl = document.createElement('span');
          newCompareEl.className = 'variant-modal__price--compare';
          newCompareEl.setAttribute('data-compare-price', '');
          newCompareEl.textContent = formatPrice(variant.compare_at_price);
          priceContainer.insertBefore(newCompareEl, currentPriceEl);
          comparePriceEl = newCompareEl;
        }
      } else if (comparePriceEl) {
        // Hide compare price if no discount
        comparePriceEl.style.display = 'none';
      }
    }

    // Check if all options are selected
    function checkAllOptionsSelected() {
      const selectedCount = Object.keys(selectedOptions).length;
      const allSelected = selectedCount === totalOptionGroups;

      if (addToCartButton) {
        if (allSelected) {
          // Verify that the selected variant is in stock
          const variant = findVariantByOptions(selectedOptions);
          const isInStock = variant && variant.available;

          if (isInStock) {
            addToCartButton.disabled = false;
            addToCartButton.style.opacity = '1';
            addToCartButton.style.cursor = 'pointer';
          } else {
            addToCartButton.disabled = true;
            addToCartButton.style.opacity = '0.5';
            addToCartButton.style.cursor = 'not-allowed';
          }
        } else {
          addToCartButton.disabled = true;
          addToCartButton.style.opacity = '0.5';
          addToCartButton.style.cursor = 'not-allowed';
        }
      }
    }

    // Check if option combination is available
    function isOptionAvailable(position, value) {
      const testOptions = { ...selectedOptions };
      testOptions[position] = value;

      return variants.some(variant => {
        let matches = true;
        Object.keys(testOptions).forEach(pos => {
          if (variant['option' + pos] !== testOptions[pos]) {
            matches = false;
          }
        });
        return matches && variant.available;
      });
    }

    // Update option button states
    function updateOptionButtons() {
      optionButtons.forEach(button => {
        const position = parseInt(button.getAttribute('data-option-position'));
        const value = button.getAttribute('data-option-value');

        if (isOptionAvailable(position, value)) {
          button.disabled = false;
        } else {
          button.disabled = true;
        }
      });
    }

    // Handle option button click
    optionButtons.forEach((button) => {
      button.addEventListener('click', function () {
        if (this.disabled) return;

        const position = parseInt(this.getAttribute('data-option-position'));
        const value = this.getAttribute('data-option-value');

        // Remove active class from siblings (sélection unique par type de variant)
        const siblings = variantModal.querySelectorAll(
          `.variant-modal__option-button[data-option-position="${position}"]`
        );
        siblings.forEach(btn => btn.classList.remove('active'));

        // Add active class to clicked button
        this.classList.add('active');

        // Update selected options
        selectedOptions[position] = value;

        // Check if all options are selected
        checkAllOptionsSelected();

        // Update button states
        updateOptionButtons();

        // Find and update variant
        const variant = findVariantByOptions(selectedOptions);
        if (variant) {
          updateVariantInfo(variant);
        }
      });
    });

    // Handle dropdown select change
    optionSelects.forEach((select) => {
      select.addEventListener('change', function () {
        const position = parseInt(this.getAttribute('data-option-position'));
        const value = this.value;

        if (!value) {
          // Reset if empty selection
          delete selectedOptions[position];
        } else {
          // Update selected options
          selectedOptions[position] = value;
        }

        // Check if all options are selected
        checkAllOptionsSelected();

        // Find and update variant
        const variant = findVariantByOptions(selectedOptions);
        if (variant) {
          updateVariantInfo(variant);
        }

        // Update other dropdowns' disabled states
        updateSelectOptions();
      });
    });

    // Update select options availability
    function updateSelectOptions() {
      optionSelects.forEach(select => {
        const position = parseInt(select.getAttribute('data-option-position'));
        const options = select.querySelectorAll('option');

        options.forEach(option => {
          if (option.value === '') return; // Skip placeholder

          const value = option.value;
          if (isOptionAvailable(position, value)) {
            option.disabled = false;
          } else {
            option.disabled = true;
          }
        });
      });
    }

    // Handle form submission
    const variantForm = variantModal.querySelector('.variant-modal__form');
    if (variantForm) {
      variantForm.addEventListener('submit', function(e) {
        e.preventDefault();

        const formData = new FormData(this);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          // Close the modal
          closeVariantModal();

          // Trigger cart update event with openDrawer flag
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
              ...data,
              openDrawer: true
            }
          }));
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        });
      });
    }

    // Pre-select first two available options by default
    function preselectFirstOptions() {
      const maxOptionsToPreselect = Math.min(2, totalOptionGroups);

      for (let position = 1; position <= maxOptionsToPreselect; position++) {
        // Find the first available (not disabled) button for this position
        const firstAvailableButton = variantModal.querySelector(
          `.variant-modal__option-button[data-option-position="${position}"]:not(:disabled)`
        );

        if (firstAvailableButton) {
          const value = firstAvailableButton.getAttribute('data-option-value');

          // Add active class
          firstAvailableButton.classList.add('active');

          // Update selected options
          selectedOptions[position] = value;

          // Also update the corresponding select dropdown
          const select = variantModal.querySelector(
            `.variant-modal__option-select[data-option-position="${position}"]`
          );
          if (select) {
            select.value = value;
          }

          // Update button states after each selection to ensure next position has correct availability
          updateOptionButtons();
        }
      }

      // Find and update variant based on pre-selected options
      const variant = findVariantByOptions(selectedOptions);
      if (variant) {
        updateVariantInfo(variant);
      }
    }

    // Initialize - first update button states, then pre-select available options
    updateOptionButtons();
    updateSelectOptions();
    preselectFirstOptions();
    checkAllOptionsSelected();
  });
  } catch(e) { console.error(e); }
})();

})();
